@if (!link) {
  <a role="button" class="external-link" tabindex="0" (click)="linkClicked.emit()" (keyup.enter)="linkClicked.emit()">
    <ng-container *ngTemplateOutlet="linkContent" />
  </a>
} @else {
  <a [href]="link" target="_blank" class="external-link" (click)="linkClicked.emit()">
    <ng-container *ngTemplateOutlet="linkContent" />
  </a>
}

<ng-template #linkContent>
  <ng-content /><span class="icon"
    >&nbsp;<app-icon
      [icon]="ICON"
      [colour]="'none'"
      [size]="ICON_SIZE"
      [margin]="{ left: 3 }"
      [style.vertical-align]="'-2px'"
    ></app-icon
  ></span>
</ng-template>
